<div class="container h-100">
    <div class="projects d-md-none">
        @if (projects && projects.length === 0) {
            <p class="text-center w-100">Er zijn nog geen (deel)projecten.</p>
        }

        @for (project of projects; track project.id) {
            <div class="project">
                <div class="name">
                    <span>{{ project.name }}</span>
                </div>
                <div class="divider"></div>
                <div class="manager">
                    {{ project.manager_user?.name }}
                </div>
                @if (project?.customer_project_phase?.name) {
                    <div class="current-phase">Huidige fase: {{ project?.customer_project_phase?.name }}</div>
                }
                @if (pendingAccessCounts[project.id]) {
                    <div class="pending-access">
                        <i class="fas fa-user-clock me-1"></i>
                        {{ pendingAccessCounts[project.id] }}
                        {{ pendingAccessCounts[project.id] === 1 ? 'toegangsverzoek' : 'toegangsverzoeken' }}
                    </div>
                }
                <div class="divider"></div>

                <div class="buttons">
                    @if (project.customer_id !== 0) {
                        <a
                            [queryParams]="{ project: project.id }"
                            class="button"
                            routerLink="/{{ Routenames.customers }}/{{ project.customer_id }}">
                            <svg-icon src="/assets/images/icons/map.svg"></svg-icon>
                            <span>Kaart ({{ project.workarea_count }})</span>
                        </a>
                    }

                    <a
                        class="button"
                        routerLink="/{{ Routenames.customers }}/{{ project.customer_id || 'template' }}/{{
                            Routenames.projects
                        }}/{{ project.id }}">
                        <svg-icon src="/assets/images/icons/customer-projects/document_white.svg"></svg-icon>
                        <span>Documentatie</span>
                    </a>

                    @if (project.customer_id !== 0) {
                        @if (Functionalities.Timeline | hasFunctionality) {
                            <a
                                class="button"
                                routerLink="/{{ Routenames.customers }}/{{ project.customer_id || 'template' }}/{{
                                    Routenames.projects
                                }}/{{ project.id }}/{{ Routenames.timeline }}">
                                <svg-icon src="/assets/svg/work.svg"></svg-icon>
                                <span>Tijdlijn</span>
                            </a>
                        }

                        <a
                            class="button"
                            routerLink="/{{ Routenames.customers }}/{{ project.customer_id || 'template' }}/{{
                                Routenames.projects
                            }}/{{ project.id }}/{{ Routenames.contacts }}">
                            <svg-icon src="/assets/images/icons/contacten_white.svg"></svg-icon>
                            <span>Contactpersonen ({{ project.contact_count }})</span>
                        </a>
                    }
                </div>
            </div>
        }
    </div>

    @if (projects?.length > 0) {
        <table
            (matSortChange)="sortProjects($event)"
            [dataSource]="projects"
            [matSortActive]="currentSort.active"
            [matSortDirection]="currentSort.direction"
            class="mat-elevation-z8 w-100 mb-4 d-none d-md-block"
            mat-table
            matSort>
            <ng-container matColumnDef="customer">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>Klantgebied</th>
                <td *matCellDef="let project" mat-cell>
                    <a routerLink="/{{ Routenames.customers }}/{{ project.customer_id }}/{{ Routenames.projects }}">
                        {{ (customers | byId: project.customer_id)?.name }}
                    </a>
                </td>
            </ng-container>
            <ng-container matColumnDef="name">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>Projectnaam</th>
                <td *matCellDef="let project" mat-cell>
                    <a
                        routerLink="/{{ Routenames.customers }}/{{ project.customer_id }}/{{ Routenames.projects }}/{{
                            project.id
                        }}">
                        {{ project.name }}
                    </a>
                </td>
            </ng-container>
            <ng-container matColumnDef="type">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>Type</th>
                <td *matCellDef="let project" mat-cell>
                    {{ project.type | projectType }}
                </td>
            </ng-container>
            <ng-container matColumnDef="consumers">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>Consumenten</th>
                <td *matCellDef="let project" mat-cell>{{ project.consumers ? 'Ja' : '' }}</td>
            </ng-container>
            <ng-container matColumnDef="manager">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>Projectleider</th>
                <td *matCellDef="let project" mat-cell>{{ project.manager_user?.name || '-' }}</td>
            </ng-container>
            <ng-container matColumnDef="phase">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>Actieve fase</th>
                <td *matCellDef="let project" mat-cell>{{ project.customer_project_phase?.name || '-' }}</td>
            </ng-container>
            <ng-container matColumnDef="workarea_count">
                <th *matHeaderCellDef mat-header-cell mat-sort-header width="50">Aantal delen</th>
                <td *matCellDef="let project" mat-cell>{{ project.workarea_count | number: '0.0-0' }}</td>
            </ng-container>
            <ng-container matColumnDef="latest_activity">
                <th *matHeaderCellDef mat-header-cell mat-sort-header width="200">Laatste wijziging</th>
                <td *matCellDef="let project" mat-cell>{{ project.latest_activity | date: 'EEE d MMM yyyy HH:mm' }}</td>
            </ng-container>
            <ng-container matColumnDef="created_at">
                <th *matHeaderCellDef mat-header-cell mat-sort-header width="200">Datum aangemaakt</th>
                <td *matCellDef="let project" mat-cell>{{ project.created_at | date: 'EEE d MMM yyyy HH:mm' }}</td>
            </ng-container>
            <ng-container matColumnDef="access">
                <th *matHeaderCellDef mat-header-cell width="150">Toegang</th>
                <td *matCellDef="let project" mat-cell>
                    @if (pendingAccessCounts[project.id]) {
                        <a
                            class="pending-access"
                            matTooltip="Openstaande toegangsverzoeken"
                            routerLink="/{{ Routenames.customers }}/{{ project.customer_id }}/{{
                                Routenames.projects
                            }}/{{ project.id }}/{{ Routenames.edit }}">
                            <i class="fas fa-user-clock me-1"></i>
                            {{ pendingAccessCounts[project.id] }}
                        </a>
                    } @else if (project.has_access === false) {
                        <span class="no-access" matTooltip="Je hebt geen toegang tot dit project">
                            <i class="fas fa-lock"></i>
                        </span>
                    }
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th *matHeaderCellDef mat-header-cell>Bewonersinformatie</th>
                <td *matCellDef="let project" mat-cell>
                    @if (project.consumers) {
                        <a
                            matTooltip="Aanmeldingen bewoners"
                            routerLink="/{{ Routenames.customers }}/{{ project.customer_id }}/{{
                                Routenames.projects
                            }}/{{ project.id }}/{{ Routenames.consumers }}">
                            <i class="ms-3 fa-solid fa-house-user"></i>
                        </a>

                        <a
                            matTooltip="Contactpersonen"
                            routerLink="/{{ Routenames.customers }}/{{ project.customer_id }}/{{
                                Routenames.projects
                            }}/{{ project.id }}/{{ Routenames.contacts }}">
                            <i class="ms-3 fa fa-people-group"></i>
                        </a>

                        @if (Functionalities.Timeline | hasFunctionality) {
                            <a
                                matTooltip="Tijdlijn"
                                routerLink="/{{ Routenames.customers }}/{{ project.customer_id }}/{{
                                    Routenames.projects
                                }}/{{ project.id }}/{{ Routenames.timeline }}">
                                <i class="ms-3 fa fa-list-ol"></i>
                            </a>
                        }

                        <a matTooltip="Updates" routerLink="/{{ Routenames.news }}">
                            <i class="ms-3 fa fa-wifi"></i>
                        </a>
                    }
                </td>
            </ng-container>
            <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
            <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
        </table>
    }
</div>
<ng-template #projectManagerFilterTemplate>
    <mat-form-field class="me-1">
        <mat-label>Filter</mat-label>
        <mat-select multiple [(ngModel)]="projectFilter" (selectionChange)="getProjects()">
            @for (type of Settings.projectTypes; track type) {
                <mat-option [value]="type.key">
                    {{ type.name }}
                </mat-option>
            }
            <mat-option value="archive"> Gearchiveerd </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field class="me-1">
        <mat-label>Filter projectleider</mat-label>
        <mat-select multiple [(ngModel)]="projectManagerFilter" (selectionChange)="changeProjectMangerFilter()">
            @for (projectManager of projectManagers; track projectManager) {
                <mat-option [value]="projectManager.id">
                    {{ projectManager.name }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>
    <mat-checkbox [(ngModel)]="onlyMyProjects" (change)="searchAndSort()" class="me-1">
        Alleen mijn projecten
    </mat-checkbox>
</ng-template>
